export default "__VITE_ASSET__D6yHo6mO__"